/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

const config = {
  auth3Url: process.env.REACT_APP_AUTH3URL,
  baseUrl: process.env.REACT_APP_BASEURL,
  // auth3Url: "https://support.mobillor.net/api/v2/users_management/users",
  // baseUrl: "https://support.mobillor.net/api/v2",
  serviceDeskId: "2",
  supportIssuesPayload: {
    projectId: process.env.REACT_APP_PROJECTID,
  },
};

export default config;
